export default "__VITE_ASSET__D6M4E1v9__"